import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.slider-logos').forEach((ev) => {
		const swiper = new Swiper('.slider-logos', {
			modules: [Pagination, Autoplay, EffectFade],
			loop: true,
			slidesPerView: 2,
			spaceBetween: 0,
			centeredSlides: true,
			preventClicks: true,
			allowTouchMove: false,
			autoplay: {
				delay: 0,
				pauseOnMouseEnter: false,
				disableOnInteraction: false,
			},
			speed: 5600,
			breakpoints: {
				// when window width is >= 480px
				480: {
					slidesPerView: 2,
				},
				// when window width is >= 640px
				700: {
					slidesPerView: 4,
				},
				1120: {
					slidesPerView: 5,
				},
				1550: {
					slidesPerView: 8,
				},
			},
		});
	});
});
